import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Lock, Loader2 } from "lucide-react";

export default function AuthGate({ children }) {
  const { user, openAuth } = useAuth();
  if (user === null)
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-emerald-400" />
      </div>
    );
  if (!user)
    return (
      <div className="max-w-md mx-auto px-4 py-24 text-center">
        <Card className="bg-[#111723] border-[#222F43] p-10" data-testid="auth-gate">
          <div className="h-12 w-12 rounded-xl bg-emerald-500/12 flex items-center justify-center mx-auto mb-4">
            <Lock className="h-6 w-6 text-emerald-400" />
          </div>
          <h2 className="font-display text-2xl font-bold mb-2">Sign in to continue</h2>
          <p className="text-slate-400 text-sm mb-6">Your trade journal and watchlist are saved to your account.</p>
          <Button onClick={openAuth} className="bg-emerald-500 hover:bg-emerald-400 text-black font-bold" data-testid="gate-signin-btn">
            Sign In / Sign Up
          </Button>
        </Card>
      </div>
    );
  return children;
}
